{
  "text": "<p>I muri i ngā ngana maha kia manatoko i tō tuakiri, kua rāhuitia mō tēnei wā tō tono kia tiakina ai tō tūmataiti.</p>\n<p>Kaua e māharahara – ka taea tonu e mātou te āwhina.</p>\n<p>Tēnā waea atu ki tā mātou rōpū kia whakaotihia tō whakaritenga:</p>\n<p><a><strong>☎️ {{phone}}</strong></a> (ka pēhia <strong>Kōwhiringa 2</strong>)<br/>Rāhina ki te Rāmere, 8am–5pm.</p>",
  "title": "Kua rāhuitia te tono hei tiaki i tō haumaru"
}
